import { VRadioGroup, VRadio } from 'vuetify/lib'
import commonMixins from './commonMixins'
import { defaultFun, makeSlots } from '../utils'
import { RADIO_BUTTONS } from '../type_name'
export default {
    name: RADIO_BUTTONS,
    mixins: [ commonMixins ],
    data() {
        return {
        
        }
    },
    computed:{
        hash() {
            const items = this.field.items || []
            return items.reduce((total, item) => {
                total[item.value] = item
                return total
            }, {})
        }
    },
    render(h) {
        const {
             // eslint-disable-next-line 
             slots,scopedSlots,
             key,
             items = [],
             change = defaultFun,
             mousedown = defaultFun,
             mouseup = defaultFun,
             ...params 
            } = this.field
            const radio_components = items.map(item => {
                let props = {}
                let scopedSlots = item.scopedSlots
                if (scopedSlots) {
                    scopedSlots = Object.keys(scopedSlots).reduce((total, key) => {
                       total[key] = makeSlots(scopedSlots[key])
                        return total
                    }, {})
                }
                if (typeof item === 'string') {
                    props = {
                        key:item,
                        label:item,
                        value:item
                    }
                } else {
                    props = item
                }
                return h(VRadio, {
                    props,
                    scopedSlots
                })
            })
               // eslint-disable-next-line 
        const { _normalized, ...other_scoped_slots} = this.scopedSlots || {}

        return h(VRadioGroup, {
            slots: this.slots,
            scopedSlots: other_scoped_slots,
            props: {
             ...params,
             value: this.my_value[key]
            },
            on: {
                change:(e) => {
                    this.my_value[key] = e
                    if (change !== defaultFun) {
                      if (typeof items[0] !== 'string') {
                        change(e, this.hash[e])
                      } else {
                        change(e)
                      }
                    
                    }
                },
                mousedown,
                mouseup,
            },
        },
        radio_components
        )
    }
}